import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MixpanelService } from "../../services/mixpanel.service";
import { RouterLinksService } from "./../../services/router-links.service";

@Component({
  selector: "app-menu-desktop",
  templateUrl: "./menu-desktop.component.html",
  styleUrls: ["./menu-desktop.component.scss"],
})
export class MenuDesktopComponent implements OnInit {
  menuList = [
    {
      link: "/",
      title: "Início",
    },
    {
      link: "/leiloes",
      title: "Leilões",
    },
    {
      link: "/como-funciona",
      title: "Como Funciona",
    },
    {
      link: "/lote/cadastrar",
      title: "Quero Vender",
    },
  ];

  constructor(
    private routes: Router,
    private routerLinksService: RouterLinksService,
    private mixpanel: MixpanelService
  ) {}

  ngOnInit(): void {}

  onMenuClick(page: any): void {
    this.mixpanel.track(`Botão | ${page.title}`, {
      item: page.title,
      rota: page.link
    });

    this.setRoute(page.link);
  }

  setRoute(path: string): void {
    this.routerLinksService.setRouteScroll(path, 1600);
  }
}
